const ServiceType = {
  VODOVOD: { label: 'Vodovod', value: 0 },
  KANALIZACIJA: { label: 'Kanalizacija', value: 1 },
};

export default ServiceType;
